import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { orderBy } from "../../utils/lodash-replacements";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useActiveFBOs } from "../../containers/ActiveFBOContainer";
import { SideIconButton } from "./SideDrawer";

interface Props {}

export const FBOMenu: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { activeFBO, setActiveFBOId, fbos } = useActiveFBOs();
  const [displayNoFBO, setDisplayNoFBO] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (!fbos.length) {
      setDisplayNoFBO(true);
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const sortedFBOs = React.useMemo(() => {
    return orderBy(fbos, ["name"], ["asc"]);
  }, [fbos]);

  return (
    <>
      <Stack direction="column" alignItems="center" spacing={-2}>
        <SideIconButton
          onClickRoute={handleMenu}
          label={t('widgets.fboMenu.switchFBO')}
          icon={<SwitchAccountIcon />}
        />
        <Typography
          variant="caption"
          color="primary.main"
          noWrap
          align="center"
          sx={{ width: "90%" }}
        >
          {activeFBO?.name}
        </Typography>
      </Stack>
      <Dialog open={displayNoFBO}>
        <DialogTitle>{t('widgets.fboMenu.noFBOTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('widgets.fboMenu.noFBOMessage')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDisplayNoFBO(false)}>{t('widgets.fboMenu.okButton')}</Button>
        </DialogActions>
      </Dialog>
      <Menu
        disablePortal
        keepMounted
        id="menu-fbo"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ zIndex: 99999999999 }}
      >
        {sortedFBOs.map((fbo) => (
          <MenuItem
            key={`active-fbo-menu-item=${fbo.id}`}
            onClick={() => {
              setActiveFBOId(fbo.id);
              window.location.href = "/#/hangars";
              window.location.reload();
            }}
            sx={{
              backgroundColor: activeFBO?.id === fbo.id ? 'common.black' : 'transparent',
              color: activeFBO?.id === fbo.id ? 'common.white' : 'text.primary',
              '&:hover': {
                backgroundColor: activeFBO?.id === fbo.id ? 'grey.900' : 'action.hover',
              },
            }}
          >
            {fbo?.subscription === "inactive" ? "× " : ""}
            {fbo.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
